import { ContentContext } from "../../../../../utils/contexts";

import {  TablePagination  } from "@mui/material";
import PaginationActions from './PaginationActions';

class Pagination extends React.PureComponent {
	static contextType = ContentContext;

	handleChangeRowsPerPage = event => {
		const { setProperty, fetchContent, searchMode, searchQuery } = this.context;

		const pageSize = parseInt(event.target.value, 10);

		setProperty("pageSize", pageSize);
		setProperty("page", 1);

		fetchContent(searchQuery, undefined, 1, undefined, undefined, pageSize);
	};

	render() {
		const { page, total, pageSize, loadingContent } = this.context;

		return (
			<TablePagination
				count={total}
				page={page - 1}
				onRowsPerPageChange={this.handleChangeRowsPerPage}
				onPageChange={() => {}}
				rowsPerPage={pageSize}
				color="primary"
				labelRowsPerPage={window.Alfresco.messages.global['edocat.pagination.rowsPerPage']}
				component="div"
				ActionsComponent={PaginationActions}
				sx={{
					flexGrow: 1,
					'& .MuiToolbar-root': {
						padding: 0,
						minHeight: 0,
					},
					'& .MuiTablePagination-selectLabel': {
						margin: '0 0.5rem',
					},
				}}
				SelectProps={{
					id: 'paginationSelect',
					disabled: loadingContent,
					sx: {
						border: '1px solid rgba(0, 0, 0, 0.23)',
						borderRadius: '4px',
						padding: '0.5rem 1.5rem 0.5rem 0.5rem',
						margin: '0 0.5rem',
						'& .MuiSelect-icon': {
							top: 'auto',
							right: '5px',
						},
					},
				}}
			/>
		);
	}
}

export default Pagination;
